<template>
  <wrld-box :headerTitle="$t('shipments.packages_weight_volume')">
    <template v-slot:boxContent>
      <!-- <h3 class="pl-4 pt-2">{{$t('shipments.total_orders_per_day')}}</h3>
      <apexchart type=bar height=170 :options="chartOptionsOrders" :series="seriesOrders" />

      <h3 class="pl-4 pt-2">{{$t('shipments.total_packages_per_day')}}</h3>
      <apexchart type=bar height=170 :options="chartOptionsPackages" :series="seriesPackages" /> -->

      <h3 class="pl-4">{{$t('shipments.total_weight_per_day')}} [KG]</h3>
      <apexchart ref="barChartOne" type="bar" height=170 :options="chartOptionsWeight" :series="seriesWeight" />

      <h3 class="pl-4">{{$t('shipments.total_volume_per_day')}} [m³]</h3>
      <apexchart ref="barChartTwo" type="bar" height=170 :options="chartOptionsVolume" :series="seriesVolume" />
    </template>
  </wrld-box>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectHits } from 'instantsearch.js/es/connectors/'
import VueApexCharts from 'vue-apexcharts'
import { algoliaService } from '@/_services'
import { generalHelpers } from '@/_helpers'

export default {
  name: 'ShipmentsMetricsPerDay',
  components: {
    'apexchart': VueApexCharts
  },
  mixins: [
    createWidgetMixin({ connector: connectHits })
  ],
  props: {
    mainDateFilter: String,
    indexName: String
  },
  data () {
    return {
      firstCall: true,
      // seriesOrders: [],
      // seriesPackages: [],
      seriesWeight: [],
      seriesVolume: [],
      // chartOptionsOrders: {
      //   chart: {
      //     id: 'orders',
      //     group: 'metrics'
      //   },
      //   colors: ['#cb00d6'],
      //   dataLabels: {
      //     enabled: false
      //   },
      //   xaxis: {
      //     type: 'datetime'
      //   },
      //   yaxis: {
      //     labels: {
      //       minWidth: 20
      //     }
      //   },
      //   annotations: {
      //     xaxis: [{
      //       x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
      //       borderColor: '#999',
      //       yAxisIndex: 0,
      //       label: {
      //         show: true,
      //         text: this.$t('shipments.today'),
      //         style: {
      //           color: '#fff',
      //           background: '#000'
      //         }
      //       }
      //     }]
      //   }
      // },
      // chartOptionsPackages: {
      //   chart: {
      //     id: 'packages',
      //     group: 'metrics',
      //     toolbar: {
      //       show: false
      //     }
      //   },
      //   colors: ['#A300D6'],
      //   dataLabels: {
      //     enabled: false
      //   },
      //   xaxis: {
      //     type: 'datetime'
      //   },
      //   yaxis: {
      //     labels: {
      //       minWidth: 20
      //     }
      //   },
      //   annotations: {
      //     xaxis: [{
      //       x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
      //       borderColor: '#999',
      //       yAxisIndex: 0,
      //       label: {
      //         show: true,
      //         text: this.$t('shipments.today'),
      //         style: {
      //           color: '#fff',
      //           background: '#000'
      //         }
      //       }
      //     }]
      //   }
      // },
      // chartOptionsWeight: {
      //   chart: {
      //     id: 'weight',
      //     // defaultLocale: 'en',
      //     locales: [{
      //       "name": "en",
      //       "options": {
      //         "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      //         "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      //         "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      //         "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      //         "toolbar": {
      //           "exportToSVG": "Download SVG",
      //           "exportToPNG": "Download PNG",
      //           "menu": "Menu",
      //           "selection": "Selection",
      //           "selectionZoom": "Selection Zoom",
      //           "zoomIn": "Zoom In",
      //           "zoomOut": "Zoom Out",
      //           "pan": "Panning",
      //           "reset": "Reset Zoom"
      //         }
      //       }
      //     },
      //     {
      //       "name": "cs",
      //       "options": {
      //         "months": ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
      //         "shortMonths": ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
      //         "days": ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
      //         "shortDays": ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
      //         "toolbar": {
      //           "exportToSVG": "Stáhnout SVG",
      //           "exportToPNG": "Stáhnout PNG",
      //           "exportToCSV": "Stáhnout CSV",
      //           "menu": "Menu",
      //           "selection": "Vybrat",
      //           "selectionZoom": "Zoom: Vybrat",
      //           "zoomIn": "Zoom: Přiblížit",
      //           "zoomOut": "Zoom: Oddálit",
      //           "pan": "Přesouvat",
      //           "reset": "Resetovat"
      //         }
      //       }
      //     }
      //   ],
      //     group: 'metrics',
      //     toolbar: {
      //       show: false
      //     }
      //   },
      //   colors: ['#7D02EB'],
      //   dataLabels: {
      //     enabled: false
      //   },
      //   xaxis: {
      //     type: 'datetime'
      //   },
      //   yaxis: {
      //     labels: {
      //       minWidth: 20
      //     }
      //   },
      //   annotations: {
      //     xaxis: [{
      //       x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
      //       borderColor: '#999',
      //       yAxisIndex: 0,
      //       label: {
      //         show: true,
      //         text: this.$t('shipments.today'),
      //         style: {
      //           color: '#fff',
      //           background: '#000'
      //         }
      //       }
      //     }]
      //   }
      // },
      // chartOptionsVolume: {
      //   chart: {
      //     id: 'volume',
      //     locales: [{
      //       "name": "en",
      //       "options": {
      //         "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      //         "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      //         "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      //         "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      //         "toolbar": {
      //           "exportToSVG": "Download SVG",
      //           "exportToPNG": "Download PNG",
      //           "menu": "Menu",
      //           "selection": "Selection",
      //           "selectionZoom": "Selection Zoom",
      //           "zoomIn": "Zoom In",
      //           "zoomOut": "Zoom Out",
      //           "pan": "Panning",
      //           "reset": "Reset Zoom"
      //         }
      //       }
      //     },
      //     {
      //       "name": "cs",
      //       "options": {
      //         "months": ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
      //         "shortMonths": ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
      //         "days": ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
      //         "shortDays": ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
      //         "toolbar": {
      //           "exportToSVG": "Stáhnout SVG",
      //           "exportToPNG": "Stáhnout PNG",
      //           "exportToCSV": "Stáhnout CSV",
      //           "menu": "Menu",
      //           "selection": "Vybrat",
      //           "selectionZoom": "Zoom: Vybrat",
      //           "zoomIn": "Zoom: Přiblížit",
      //           "zoomOut": "Zoom: Oddálit",
      //           "pan": "Přesouvat",
      //           "reset": "Resetovat"
      //         }
      //       }
      //     }
      //   ],
      //     group: 'metrics',
      //     toolbar: {
      //       show: false
      //     }
      //   },
      //   colors: ['#5653FE'],
      //   dataLabels: {
      //     enabled: false
      //   },
      //   xaxis: {
      //     type: 'datetime'
      //   },
      //   yaxis: {
      //     labels: {
      //       minWidth: 20
      //     }
      //   },
      //   annotations: {
      //     xaxis: [{
      //       x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
      //       borderColor: '#999',
      //       yAxisIndex: 0,
      //       label: {
      //         show: true,
      //         text: this.$t('shipments.today'),
      //         style: {
      //           color: '#fff',
      //           background: '#000'
      //         }
      //       }
      //     }]
      //   }
      // }
    }
  },
  mounted () {
    this.$refs.barChartOne.chart.setLocale(this.$i18n.locale)
    this.$refs.barChartTwo.chart.setLocale(this.$i18n.locale)
  },
  beforeUpdate () {
    this.$refs.barChartOne.chart.setLocale(this.$i18n.locale)
    this.$refs.barChartTwo.chart.setLocale(this.$i18n.locale)
  },
  computed: {
    ...mapGetters(['getLoggedInUserOrganizationID']),
    ...mapState(['generalApp']),
    chartOptionsWeight () {
      let chartOptionsWeight = {
        chart: {
          id: 'weight',
          group: 'metrics',
          toolbar: {
            show: false
          }
        },
        colors: ['#7D02EB'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          labels: {
            minWidth: 20
          }
        },
        annotations: {
          xaxis: [{
            x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: this.$t('shipments.today'),
              style: {
                color: '#fff',
                background: '#000'
              }
            }
          }]
        }
      }
      return chartOptionsWeight
    },
    chartOptionsVolume () {
      let chartOptionsVolume = {
        chart: {
          id: 'volume',
          group: 'metrics',
          toolbar: {
            show: false
          }
        },
        colors: ['#5653FE'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          labels: {
            minWidth: 20
          }
        },
        annotations: {
          xaxis: [{
            x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: this.$t('shipments.today'),
              style: {
                color: '#fff',
                background: '#000'
              }
            }
          }]
        }
      }
      return chartOptionsVolume
    },
    needForUpdateData () {
      return { dateFilter: this.generalApp.algoliaDateFilters, allFilter: this.generalApp.allSelectedFilters }
    }
  },
  methods: {
    ...mapActions({
      startLoading: 'startLoading',
      stopLoading: 'stopLoading'
    }),
    async getData () {
      this.startLoading()

      let dateRange = {}
      for (let i = 0; i < Object.keys(this.generalApp.algoliaDateFilters).length; i++) {
        const dateField = this.generalApp.algoliaDateFilters[Object.keys(this.generalApp.algoliaDateFilters)[i]]
        const splitted = dateField.split(':')
        if (splitted[0] === this.mainDateFilter) {
          const timeStamps = splitted[1].split(' ')
          dateRange = { from: Number(timeStamps[0]), to: Number(timeStamps[2]) }
        }
      }
      let orgID = this.getLoggedInUserOrganizationID
      const chunkSize = 32 // number of how many days will be included in 1 Algolia call (ideal if power of 2)
      const data = await algoliaService.getHitsDayByDay(this.indexName, this.generalApp.allSelectedFilters, this.mainDateFilter, dateRange, chunkSize, orgID)
      const dataLength = data.length
      let groupedByDate = {}

      for (let i = 0; i < dataLength; i++) {
        const element = data[i]
        const timeStamp = element.pickupLocal.from

        if (groupedByDate[timeStamp] === undefined) {
          groupedByDate[timeStamp] = {
            // orders: 0,
            // packages: 0,
            weight: 0,
            volume: 0
          }
        }
        // const orders = groupedByDate[timeStamp].orders + (element.orders.deliveries ? element.orders.deliveries : element.orders)
        // const packages = groupedByDate[timeStamp].packages + element.packages
        const weight = groupedByDate[timeStamp].weight + (element.weight.total ? element.weight.total : element.weight)
        const volume = groupedByDate[timeStamp].volume + (element.volume.total ? element.volume.total : element.volume)

        groupedByDate[timeStamp] = {
          // orders: orders,
          // packages: packages,
          weight: weight / 1000,
          volume: volume
        }
      }

      // let seriesOrders = []
      // let seriesPackages = []
      let seriesWeight = []
      let seriesVolume = []

      const groupedByDateLength = Object.keys(groupedByDate).length

      for (let i = 0; i < groupedByDateLength; i++) {
        const date = Object.keys(groupedByDate)[i] * 1000
        const values = groupedByDate[Object.keys(groupedByDate)[i]]

        // seriesOrders.push([date, values.orders])
        // seriesPackages.push([date, values.packages])
        seriesWeight.push([date, Math.round(values.weight * 100) / 100])
        seriesVolume.push([date, Math.round(values.volume * 100) / 100])
      }

      // TODO: add to i18n
      // this.seriesOrders = [{ name: 'Orders', data: seriesOrders }]
      // this.seriesPackages = [{ name: 'Packages', data: seriesPackages }]
      this.seriesWeight = [{ name: this.$t('reports.weight'), data: seriesWeight }]
      this.seriesVolume = [{ name: this.$t('reports.volume'), data: seriesVolume }]

      this.stopLoading()
    }
  },
  watch: {
    needForUpdateData: {
      deep: true,
      handler (nawVal, oldVal) {
        if (!generalHelpers.isEqual(nawVal, oldVal) || this.firstCall) {
          this.getData()
          this.firstCall = false
        }
      }
    }
  }
}
</script>
